import React from 'react';
import css from './Sections.module.css';
import classNames from 'classnames';
import { categoryQueryParam } from '../../../util/categories';

import technicalSuitsImg from './FeaturedCategoryIcons/technicalSuitsImg.jpg';
import trainingGearImg from './FeaturedCategoryIcons/trainingGearImg.jpg';
import techWearablesImg from './FeaturedCategoryIcons/wearables.avif';

function SectionCategory({ useHistoryPush, intl }) {
  const productCategories = [
    {
      key: 'technicalSuits',
      label: intl.formatMessage({
        id: 'SectionCategory.category.technicalSuits',
      }),
      img: technicalSuitsImg,
      query: categoryQueryParam('technicalSuits'),
    },
    {
      key: 'trainingGear',
      label: intl.formatMessage({
        id: 'SectionCategory.category.trainingGear',
      }),
      img: trainingGearImg,
      query: categoryQueryParam('trainingGear'),
    },
    {
      key: 'techAndWearables',
      label: intl.formatMessage({
        id: 'SectionCategory.category.techAndWearables',
      }),
      img: techWearablesImg,
      query: categoryQueryParam('techAndWearables'),
    },
  ];

  return (
    <div className={classNames(css.sectionGetConnected)}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>
              {intl.formatMessage({
                id: 'SectionCategory.title',
              })}
            </h2>
          </div>
        </div>

        <div className={css.sectionContent}>
          {productCategories.map(cat => (
            <div
              key={cat.key}
              className={css.contentBlock}
              role="button"
              onClick={() => useHistoryPush('SearchPage', {}, cat.query)}
            >
              <div className={css.contentImg}>
                <img src={cat.img} alt={cat.label} />
              </div>
              <h3>{cat.label}</h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SectionCategory;
